import * as React from 'react'

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    ListItem,
    useMediaQuery
} from '@mui/material'
import { Logout } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

import BannerGoMidiaBH from '../../../../assets/images/header/bannerGomidiabh.png';
import BannerGomidiaVerde from '../../../../assets/images/middle/aboutUs/gomidia-transfacil-verde.jpg';
import BannerGomidiaAcelere from '../../../../assets/images/middle/aboutUs/gomidia-acelereseunegocio-semtelefone.jpg';
import BannerGomidiaTodomundo from '../../../../assets/images/middle/aboutUs/gomidia-todomundove-semtelefone.jpg';
import BannerGomidiaAcerte from '../../../../assets/images/middle/aboutUs/gomidia-acertenamidia-semtelefone.jpg';

import { ItemText } from '../../../itemText';
import { AboutUsComp, AboutUsContent, TextBody, TextContent, TextTitle, VideoContent } from './styles';
import VideoPlayer from '../../../VideoPlayer/VideoPlayer';
import videoFile from "../../../../assets/videos/video_bhbusmidia.mp4";

interface INavBar {
    
}

const videoJsOptions = {
    sources: [
      {
        src: videoFile,
        type: "video/mp4"
      }
    ]
  };
  

const NossaSolucao: React.FC<INavBar> = () => {
    const navigate = useNavigate();
    const matches = useMediaQuery('(max-width:700px)');
    const matches2 = useMediaQuery('(max-width:1100px)');


    return (
        <AboutUsComp id='nossol'>
            <AboutUsContent>
                <TextContent>
                    <TextTitle>
                        <h1>NOSSA SOLUÇÃO</h1>
                        <h2>Porque somos a melhor opção?</h2>
                    </TextTitle>
                    <TextBody>
                        <p>
                            O <strong>Backbus</strong> é uma mídia OOH, o formato permite que toda a traseira seja utilizada para exibição da sua marca!
                        </p>
                        <p>
                            Essa mídia alcança um alto número de pessoas trazendo mais visibilidade para quem anuncia. É a mídia em movimento, com mais impacto para as empresas, de forma eficaz e rentável.
                        </p>
                    </TextBody>
                </TextContent>
                <VideoContent>
                    <VideoPlayer options={videoJsOptions} />
                </VideoContent>
            </AboutUsContent>
        </AboutUsComp>
    );
}

export { NossaSolucao }